<template>
  <f7-page id="page-invite-earn" name="invite-earn" @page:afterin="afterin">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link class="customBack" color="black"><i class="f7-icons">chevron_left</i></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block class="mt-xxl mb-xxl">
      <h1 class="wandr-title-1 mb-0 fw-bold">Invite & Earn</h1>
      <p>Love our service?<br />Don't keep us a secret!</p>
      <p>Invite your friends to join us and earn a SGD 20 rewards when they complete a single transfer of SGD 2000 or more within the first 6 months of their registration.</p>
      <p>It's a simple way to earn a little extra just by sharing the benefits of our service with others.</p>
      <f7-card class="px-3 py-3">
        <p class="mt-0">Log in to your Wandr-E account to get your unique referral link today!</p>
        <f7-button large fill round @click="$event=>redirectLogin()">Log in</f7-button>
      </f7-card>
      <p>By inviting friends with the referral link, you agree to the <f7-link href="/guest-invite-earn-tnc">Terms & Conditions for Invite & Earn</f7-link></p>
    </f7-block>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";

  export default {
    data() {
      return {
        couponAmount : 20
      }
    },
    mounted(){
    },
    computed: {
      ...mapGetters('auth', ['loggedIn']),
    },
    methods: {
      ...mapActions('misc', ['setRedirectAfterLogin']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
        if(this.loggedIn){
        this.setRedirectAfterLogin(["/account/invite-earn", Date.now()])
          this.$f7router.navigate("/home");
        }
      },
      redirectLogin(){
        this.setRedirectAfterLogin(["/account/invite-earn", Date.now()])
        this.$f7router.navigate("/login");
      }
    }
  }
</script>